import { HTMLAttributes } from 'react';

function cn(...classes: (string | undefined | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-secondary/10 animate-pulse rounded-md', className)}
      {...props}
    />
  );
}
